module.exports = __webpack_public_path__ + "static/media/mainTitleImg.70363faa.svg";